// vendor styles
import 'normalize.css/normalize.css'

// website specific styles and scripts
import './styles/common.scss'
import './styles/main.scss'
import './scripts/main.js'



/** WEBPACK FOOTER **
 ** ./assets/index.js
 **/